import React, { useState } from 'react';

interface CollapsibleProps {
  title: string;
  className?: string;
  tags?: string[];
}

const Collapsible: React.FC<CollapsibleProps> = ({ title, className, tags, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`collapsible ${isOpen ? 'open' : ''}`}>
      <div className={`collapsible__toggle ${className}`}
        tabIndex={0}
        onKeyUp={(e)=>{ e.key === "Enter" && toggleCollapse()}}
        onClick={toggleCollapse}>
          <div className="collapsible__toggle--tag">
            {tags?.map((tag, i)=>{
              return (
                <span key={i}>{tag}</span>
              )
            })}
          </div>
        <span className="collapsible__toggle--header">{title}</span>
      </div>
      <div className="collapsible__content-wrapper">
        <div className="collapsible__content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Collapsible;